/**
© BlockyApps. You are permitted to use this content within your store. Redistribution or use in any other application is strictly prohibited. 
Unauthorized copying, distribution, or reproduction in any form will result in legal action.
**/
if (!customElements.get('blocky-accordion')) {
  customElements.define('blocky-accordion',
    class BlockyAccordion extends HTMLElement {
      constructor() {
        super()

        this.querySelectorAll('.blocky-accordion-btn').forEach(button => {
          button.addEventListener('click', () => {
            const answer = button.nextElementSibling;
            button.classList.toggle('active');
            answer.classList.toggle("active")        
          });
        });
      }
    }
  )
}
document.querySelectorAll('.blocky-accordion-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var current = btn;
    document.querySelectorAll('.blocky-accordion-btn').forEach(function(otherBtn) {
      if (otherBtn !== current && otherBtn.classList.contains('active')) {
        otherBtn.classList.remove('active');
        otherBtn.nextElementSibling.classList.remove('active');
      }
    });
  });
});

